import cls from 'classnames';
import ContactsWidget from 'components/ContactsWidget';
import Footer from 'components/Footer';
import Header from 'components/Header';
import React from 'react';
import BuildIcon from 'svg/BuildIcon';
import PersonGroupIcon from 'svg/PersonGroupIcon';
import PersonIcon from 'svg/PersonIcon';
import { BREAKPOINTS } from 'constants/styles';
import MyOceanIcon from 'svg/MyOceanIcon';
import { APP_STORE, GOOGLE_PLAY } from '../consts';
import useStyles from './styles';

interface IProps {
}

const RootPage: React.FC<IProps> = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Header />
      <div className={classes.page}>
        <MyOceanIcon className={classes.logo} />
        <h1 className={classes.titleLabel}>We make maritime mobility efficient</h1>
        <p className={classes.descriptionLabel}>
          The leading spend management platform powering maritime mobility
        </p>
        <picture>
          <source srcSet="/img/root/iphone.png" media={`(max-width: ${BREAKPOINTS.MD}px)`} />
          <img
            className={classes.macbook}
            src="/img/root/macbook.png"
            alt="Overview"
          />
        </picture>
        <div>
          <h3 className={cls(classes.subtitle, classes.valuesSubtitle)}>
            We bring value to the industry
          </h3>

          <div className={classes.valueList}>
            <div className={classes.valueItem}>
              <BuildIcon />
              <p className={classes.valueItemTitle}>Transparent expenses report of cash flow</p>
              <p className={classes.valueItemBade}>Owner</p>
            </div>
            <div className={classes.valueItem}>
              <PersonIcon />
              <p className={classes.valueItemTitle}>An intuitive instrument for expenses control and validation</p>
              <p className={classes.valueItemBade}>Management company</p>
            </div>
            <div className={classes.valueItem}>
              <PersonGroupIcon />
              <p className={classes.valueItemTitle}>Easy way to make purchase orders, skipping past the bureaucracy</p>
              <p className={classes.valueItemBade}>Captain & Crew</p>
            </div>
          </div>
        </div>

        <div>
          <h3 className={cls(classes.subtitle, classes.solutionSubtitle)}>
            Our solution
          </h3>

          <div className={classes.solutions}>
            <div className={classes.solution}>
              <div className={classes.solutionImgContainer}>
                <img
                  className={classes.solutionImg}
                  src="/img/root/invoice.png"
                  alt="Invoice"
                />
              </div>
              <div className={classes.solutionText}>
                <h4 className={classes.solutionTitle}>Process, manage and recharge expenses fast</h4>
                <p className={classes.solutionDescription}>
                  Using proprietary OCR and AI technology, MyOcean can automate up to 90% of routine expense
                  capture/processing.
                </p>
              </div>
            </div>

            <div className={cls(classes.solution, classes.solutionReverse)}>
              <div className={classes.solutionImgContainer}>
                <img
                  className={classes.solutionImg}
                  src="/img/root/dashboard.png"
                  alt="Dashboard"
                />
              </div>
              <div className={classes.solutionText}>
                <h4 className={classes.solutionTitle}>Purchase order management</h4>
                <p className={classes.solutionDescription}>
                  Track every piece of work necessary to conduct on the yacht
                </p>
              </div>
            </div>

            <div className={classes.solution}>
              <div className={classes.solutionImgContainer}>
                <img
                  className={classes.solutionImg}
                  src="/img/root/benchmark.png"
                  alt="Benchmark"
                />
              </div>
              <div className={classes.solutionText}>
                <h4 className={classes.solutionTitle}>Benchmark your quotes</h4>
                <p className={classes.solutionDescription}>
                  Compare your quotes with other vendors
                </p>
              </div>
            </div>

            <div className={cls(classes.solution, classes.solutionReverse)}>
              <div className={classes.solutionImgContainer}>
                <img
                  className={classes.solutionImg}
                  src="/img/root/request_name.png"
                  alt="Request"
                />
              </div>
              <div className={classes.solutionText}>
                <h4 className={classes.solutionTitle}>Refit</h4>
                <p className={classes.solutionDescription}>
                  Track everything now. Discuss with the team later
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className={classes.mobileApp}>
          <div className={classes.mobileImgContainer}>
            <img
              className={classes.mobileImg}
              src="/img/root/mobile.png"
              alt="Mobile app"
            />
          </div>
          <div className={classes.mobileText}>
            <p className={classes.mobileTitle}>Easy access via Mobile app</p>
            <p className={classes.mobileDescription}>
              Expenses capture, requests for quotation, automatic digitization of invoices, quotes and receipts,
              reconciliation of expenses with credit cards
            </p>

            <div className={classes.storeButtons}>
              <a href={APP_STORE} target="_blank" rel="noreferrer" className={classes.storeButton}>
                <img
                  src="/img/root/app_store.png"
                  alt="App Store"
                />
              </a>
              <a href={GOOGLE_PLAY} target="_blank" rel="noreferrer" className={classes.storeButton}>
                <img
                  src="/img/root/google_play.png"
                  alt="Google play"
                />
              </a>
            </div>
          </div>
        </div>

        <ContactsWidget title="Contact us to learn more about MyOcean" />

        <Footer />
      </div>
    </div>
  );
};

export default RootPage;
